/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import { MenuItem } from '@material-ui/core';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TableHeaderForManufacturer } from './TableHeaderForManufacturer';
import { TableHeadForChecks, hideColumns } from './TableHeadForChecks';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  array_move,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  QUARTER_VALUE_REQUIRED,
  REBATE_PROGRAM_REQUIRED,
  NO_DATA_FOR_FILTER_SELECT,
  REQUEST_DATE_INVALID_FORMAT_CBI,
  STATUS_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getCommonDropdownList,
  getQuarterData,
  getCheckBoxValue,
  getManufacturerData,
  getCheckDetailsData,
  dispatchErrorMessageData,
  setSelectedRebateProgram,
  disQuarter,
  disSearchDisabled,
  disRowSelected,
  dispatchCheckDetailsData,
  dispatchQuarterForAPI,
} from '../store/actions';
import {
  viewPortHeight,
  viewPortHeight_355,
  viewPortHeight_350_cbi,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  ActionCellRenderer,
  DateRenderer,
  CheckCellRender,
} from './FrameworkComponent';
import {
  DefaultPlanType,
  planTypeMedicaid,
  quarterLabelName,
  radioGroupLabelName,
  rebateProgramLabelName,
} from './ConstantData';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';

const ChecksByInvoice = () => {
  const [manfData,setManfData] = useState({});
  const [quartData, setQuartData] = useState('');
  const [gridApi, setGridApi] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [fullScreenViewForChecks, setFullScreenViewForChecks] = useState(false);
  const [planType, setPlanType] = useState('');
  const [qtrForAPI, setQtrForAPI] = useState('');
  const [quarterValue, setQuarterValue] = useState('');
  const [rebateProgramList, setRebateProgramList] = useState([]);

  const [rebateProgram, setRebateProgram] = useState('');
  const [radioList, setRadioList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mfgDetailslist, setMfgDetailslist] = useState([]);
  const [getCheckList, setGetCheckList] = useState([]);

  const [isFilter, setIsFilter] = useState(false);
  const [supressError, setSupressError] = useState(false);
  const [colHeadCheck, setColHeadCheck] = useState(TableHeadForChecks);
  const [totalResultCount, setTotalResultCount] = useState(0);

  const [tableDataState, setTableDataState] = useState(false);
  const [rebateDropdownList, setRebateDropdownList] = useState([]);
  const dispatch = useDispatch();

  const getQuarterfromAPIInRedux = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.quarterInAPI
  );
  const getQuarterDataValue = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.quarter
  );
  const getPlanTypeData = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.checkbox
  );
  const getManufacturerDataList = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.manufacturer
  );
  const getCheckDetailsList = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.checkDetails
  );
  const getErrorMsg = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.errorMessageInRedux
  );
  const selectedData = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.selectedRebateProgram
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const quarterInRedux = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.quarterInput
  );

  const generalSystemParameterDetails = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );
  const searchDisable = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.searchStatus
  );
  const [gridParams, setGridParams] = useState('');
  const rowSelectedInRedux = useSelector(
    (state) => state.sharedState.CheckByInvoiceReducer.rowSelected
  );
  // Select data useEffect
  React.useEffect(() => {
    setPlanType(selectedData?.plan);
    setRebateProgram(selectedData?.rebateProgram);
  }, [selectedData]);

  // Select data useEffect
  React.useEffect(() => {
    let dis = false;
    if (quarterValue) {
      dis = false;
    } else {
      dis = true;
    }
    dispatch(disSearchDisabled(dis));
  }, [quarterValue]);

  // By default handle data useEffect
  React.useEffect(() => {
    if (!selectedData?.plan) {
      setPlanType(userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD');
      setRebateProgram(
        userDefaults?.rebateProgramCd ? userDefaults?.rebateProgramCd : '-1'
      );

      dispatch(
        setSelectedRebateProgram({
          plan: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
          rebateProgram: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
        })
      );
    }
  }, [userDefaults]);

  // User defaults handling for CCN and batchNumber useEffect
  React.useEffect(() => {
    if (generalSystemParameterDetails?.[0]?.checkLogByCcnInd !== 1) {
      TableHeadForChecks.forEach((element) => {
        if (element.headerName === 'CCN') {
          element.hide = true;
        }
      });
    }
    if (generalSystemParameterDetails?.[0]?.checkLogUsesBatchInd !== 1) {
      TableHeadForChecks.forEach((element) => {
        if (element.headerName == 'Batch Number') {
          element.hide = true;
        }
      });
    }

    setColHeadCheck(TableHeadForChecks);
  }, [generalSystemParameterDetails]);

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!getPlanTypeData?.PLAN_TYPE_CD) {
      dispatch(getCheckBoxValue());
    }
    setTableDataState(true);
  }, []);

  // Dropdown values useEffect
  React.useEffect(() => {
    const planList =
      getPlanTypeData &&
      getPlanTypeData.PLAN_TYPE_CD &&
      getPlanTypeData.PLAN_TYPE_CD.length > 0 &&
      getPlanTypeData.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj?.codeValueID?.codeValue === 'FD'
              ? planTypeMedicaid
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
    setRadioList(planList);

    setPlanType(selectedData?.plan);
  }, [getPlanTypeData]);

  // quarter by default useEffect
  React.useEffect(() => {
    if (!quarterInRedux) {
      dispatch(getQuarterData());
    }
  }, []);

  // dropdown list refresh case
  React.useEffect(() => {
    if (planType) {
      getCommonDropdownList(planType).then((resp) => {
        setRebateDropdownList(resp);
      });
    }
  }, [planType]);

  React.useEffect(() => {
    let list = [];
    if (
      rebateDropdownList?.status === STATUS_MSG &&
      rebateDropdownList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(rebateDropdownList.data)) {
        list = _.map(rebateDropdownList.data, (val, ind) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name?.toLowerCase().localeCompare(val.name?.toLowerCase())
      )
    );
  }, [rebateDropdownList]);

  // onSearch click button
  const onSearch = async (localQ) => {
    let arr = [];
     dispatch(dispatchErrorMessageData([]));
    if (rebateProgram != '-1') {
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, {
            field: 'rebate',
            errorType: 'required',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    } else {
      arr.push({
        field: 'rebate',
        errorType: 'required',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    let quarteFine = false;
    if (!localQ) {
      setSupressError(false);
      if (quarterValue && !_.isEmpty(quarterValue) && !_.isNaN(quarterValue)) {
        const re_test = /[1-4]{1}[qQ]{1}\d{4}$/;
        const re_test2 = /[1-4]{1}[qQ]{1}\d{2}$/;
        const indexOf = !_.isEmpty(arr)
          ? _.findIndex(arr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          arr.splice(indexOf, 1);
        }
        if (re_test.test(quarterValue) || re_test2.test(quarterValue)) {
          const indexOf = !_.isEmpty(arr)
            ? _.findIndex(arr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            arr.splice(indexOf, 1);
          }
          quarteFine = true;
          arr = arr.filter((item) => item.field != 'quarter');
        } else {
          arr = arr.filter((item) => item.field != 'quarter');
          arr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        arr = arr.filter((item) => item.field != 'quarter');
        arr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }

    if ((quarteFine || localQ) && rebateProgram != '-1') {
      setLoading(true);
      setTableDataState(false);
      let quart = '';
      if (quarterValue) {
        quart = quarterValue?.toUpperCase();
      } else if (localQ) {
        quart = localQ?.toUpperCase();
      }
      setQuarterValue(quart);

      setQtrForAPI(quart);
      dispatch(dispatchQuarterForAPI(quart));
      dispatch(disQuarter(quart));

      const data = {
        planType: planType,
        rebateProg: rebateProgram,
        qtr: quarterValue || localQ,
      };
      dispatch(disRowSelected({}));
      const resp = await dispatch(getManufacturerData(data));
      setQuartData(quart)
      setManfData(resp)
      if (resp?.manufacturer.data?.length == 0) {
        arr = updateErrorMessages({
          existingErrors: arr,
          field: 'global',
          errorType: 'noData',
          message: 'No records found.',
          condition: Array.isArray(resp?.data) && resp.data.length > 0, // true = remove error
        });
        dispatch(dispatchErrorMessageData(arr));
      }
    }

    const unique = [...new Set(arr)];
    let arrayLocal = [];
    if (localQ) {
      arrayLocal = [];
    } else {
      arrayLocal = unique;
    }
    dispatch(dispatchErrorMessageData(arrayLocal));
  };

  const quarterFormate = (value) => {
    const data = value;
    const d = data.split('');
    d.splice(4, 0, 'Q');
    const d1 = d.join('').split('Q').reverse('');
    d1.splice(1, 0, 'Q');
    const output = d1.join('');
    return output;
  };
  React.useEffect(()=>{
    if (manfData?.manufacturer?.data?.length > 0) {
      gridParams.api.forEachNode(
        (node) => node.rowIndex === 0 && node.setSelected(true)
      );

      setGridParams(gridParams);
      const selectedRowNodes = gridParams.api.getSelectedNodes();
      onRowSelect(selectedRowNodes[0]?.data, quartData);
      setManfData({})
    }
  },[manfData])
  React.useEffect(() => {
    let quarter = '';
    if (!quarterInRedux) {
      if (
        getQuarterDataValue?.status === STATUS_MSG &&
        getQuarterDataValue?.message === SUCCESS_MSG
      ) {
        const receivedQuarter = getQuarterDataValue.data;
        if (receivedQuarter) {
          quarter = quarterFormate(receivedQuarter);
        }
      }
      setSupressError(true);
      setQuarterValue(quarter);

      setQtrForAPI(quarter);
      dispatch(dispatchQuarterForAPI(quarter));
      onSearch(quarter);

      dispatch(disQuarter(quarter));
    } else {
      setQuarterValue(quarterInRedux);

      dispatch(dispatchQuarterForAPI(quarterInRedux));
      setQtrForAPI(getQuarterfromAPIInRedux || '');
    }
  }, [getQuarterDataValue]);

  // manufacturer table data useEffect
  React.useEffect(() => {
    let mfgList = [];
    let arr = getErrorMsg || [];
    setLoading(false);
    if (
      getManufacturerDataList?.status === STATUS_MSG &&
      getManufacturerDataList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getManufacturerDataList.data)) {
        mfgList = _.map(getManufacturerDataList.data, (val, ind) => ({
          ...val,
          mfgId: val.mfgId,
          mfgName: val.mfgName,
        }));
        const indexOf = !_.isEmpty(arr)
          ? _.findIndex(arr, {
              field: 'mfgGrid',
              errorType: 'noData',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          arr.splice(indexOf, 1);
        }
        setTableDataState(true);
      } else {
        arr = arr.filter((item) => item.errorType != 'noData');
        arr.push({
          field: 'mfgGrid',
          errorType: 'noData',
          message: NO_DATA_FOR_FILTER_SELECT,
        });
        setTableDataState(true);
        dispatch(dispatchCheckDetailsData([]));
      }
    }
    setMfgDetailslist(
      mfgList.sort((key, val) =>
        key.mfgName?.toLowerCase().localeCompare(val.mfgName?.toLowerCase())
      )
    );

    const unique = [...new Set(arr)];
    let arrayLocalNew = [];
    if (supressError) {
      arrayLocalNew = [];
    } else {
      arrayLocalNew = unique;
    }
    dispatch(dispatchErrorMessageData(arrayLocalNew));
    setLoading(false);
  }, [getManufacturerDataList]);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));

    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/checksByInvoice') {
          if (getErrorMsg && getErrorMsg.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [JSON.stringify(getErrorMsg)]);

  // check table data useEffect
  React.useEffect(() => {
    let checkList = [];
    let arr = getErrorMsg || [];
    if (
      getCheckDetailsList?.status === STATUS_MSG &&
      getCheckDetailsList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getCheckDetailsList.data)) {
        checkList = _.map(getCheckDetailsList.data, (val, ind) => ({
          ...val,
          checkLogNum: val.checkLogNum,
          batchNum: val.batchNum,
          checkIdentifier: val.checkIdentifier,
          batchDt: val.batchDt,
          checkNum: val.checkNum,
          checkIssuer: val.checkIssuer,
          checkInfo: val.checkInfo,
          checkDt: val.checkDt,
          postmarkedDt: val.postmarkedDt,
          receivedDt: val.receivedDt,
          checkAmt: val.checkAmt,
          totAllocatedAmt: val.totAllocatedAmt,
          paymentMediaTypeCd: val.paymentMediaTypeCd,
          disputeResolutionCd: val.disputeResolutionCd,
        }));
        const indexOf = !_.isEmpty(arr)
          ? _.findIndex(arr, {
              field: 'checkGrid',
              errorType: 'noData',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          arr.splice(indexOf, 1);
        }
      } else {
        arr = arr.filter((item) => item.errorType != 'noData');
        arr.push({
          field: 'checkGrid',
          errorType: 'noData',
          message: NO_DATA_FOR_FILTER_SELECT,
        });
            arr = updateErrorMessages({
      existingErrors: arr,
      field: 'checkGrid',
      errorType: 'noData',
      message: NO_DATA_FOR_FILTER_SELECT,
     // condition: hasData, // remove if data is present
    });
      }
    }

    setGetCheckList(checkList);
    const unique = [...new Set(arr)];
    let arrayLocal = [];
    if (supressError) {
      arrayLocal = [];
    } else {
      arrayLocal = unique;
    }
    dispatch(dispatchErrorMessageData(arrayLocal));
    setLoading(false);
  }, [getCheckDetailsList]);
  const updateErrorMessages = ({
    existingErrors = [],
    field,
    errorType,
    message,
    condition, // true = remove error, false = add error
  }) => {
    let updatedErrors = [...existingErrors];

    const index = _.findIndex(updatedErrors, { field, errorType });

    if (condition) {
      // Remove error if present
      if (index >= 0) {
        updatedErrors.splice(index, 1);
      }
    } else {
      // Add if not already present
      if (index < 0) {
        updatedErrors.push({ field, errorType, message });
      }
    }

    return [...new Set(updatedErrors)];
  };

  // quarter input function
  const quarterChangeHandler = (e) => {
    setQuarterValue(e.target.value);
    dispatch(disQuarter(e.target.value));
    let dis = false;
    if (e.target.value) {
      dis = false;
    } else {
      dis = true;
    }
    dispatch(disSearchDisabled(dis));
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleFullScreenViewForChecks = () => {
    setFullScreenViewForChecks(!fullScreenViewForChecks);
  };

  const frameworkComponents = {
    ActionCellRender: ActionCellRenderer,
    DateRenderer: DateRenderer,
    CheckCellRender: CheckCellRender,
  };

  // by default 1st row selection function
  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridParams(params);
    if (rowSelectedInRedux?.mfgId) {
      params.api.forEachNode(
        (node) =>
          node?.data?.mfgId == rowSelectedInRedux?.mfgId &&
          node?.setSelected(true)
      );
    } else {
      params.api.forEachNode(
        (node) => node?.rowIndex == 0 && node?.setSelected(true)
      );
    }

    const selectedRowNodes = params.api.getSelectedNodes();
    onRowSelect(selectedRowNodes[0]?.data);
  };

  //  row selection function
  const onRowSelect = (row, quart, reduxState) => {
    if (row?.mfgId) {
      dispatch(disRowSelected({ mfgId: row?.mfgId }));
      if (row?.mfgId != rowSelectedInRedux?.mfgId) {
        setLoading(true);
        dispatch(
          getCheckDetailsData({
            mfgId: row?.mfgId,
            rebateProgramCd: reduxState
              ? reduxState.rebateProgram
              : rebateProgram,
            qtr: reduxState
              ? getQtrVal(reduxState.quarterValue)
              : quart
              ? getQtrVal(quart)
              : getQtrVal(qtrForAPI),
          })
        );
      }
    }
  };

  const getQtrVal = (value) => {
    if (value) {
      const newValue = value?.toLowerCase();
      let newVal = newValue?.split('q');
      if (value.length <= 4) {
        let curtYears = moment().format('YYYY');
        curtYears = `${_.join(_.split(curtYears, '', 2), '')}${newVal[1]}`;
        newVal = `${curtYears}${newVal[0]}`;
      } else {
        newVal = newVal[1] + newVal[0];
      }
      return newVal;
    }
  };

  //  focus out validations function
  const onBlurFunction = (keyVal, val) => {
    let arr = getErrorMsg ? (getErrorMsg.length > 0 ? getErrorMsg : []) : [];

    const data = val;
    if (keyVal == 'quarter') {
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const re_test = /[1-4]{1}[qQ]{1}\d{4}$/;
        const re_test2 = /[1-4]{1}[qQ]{1}\d{2}$/;
        const indexOf = !_.isEmpty(arr)
          ? _.findIndex(arr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          arr.splice(indexOf, 1);
        }
        if (re_test.test(data) || re_test2.test(data)) {
          const indexOf = !_.isEmpty(arr)
            ? _.findIndex(arr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            arr.splice(indexOf, 1);
          }
          arr = arr.filter((item) => item.field != 'quarter');
          setQuarterValue(autoFormateDate(data?.toUpperCase()));

          dispatch(disQuarter(autoFormateDate(data?.toUpperCase())));
        } else {
          arr = arr.filter((item) => item.field != 'quarter');
          arr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        arr = arr.filter((item) => item.field != 'quarter');
        arr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }

    if (keyVal == 'rebate') {
      if (data != '-1') {
        const indexOf = !_.isEmpty(arr)
          ? _.findIndex(arr, {
              field: 'rebate',
              errorType: 'required',
            })
          : null;
        if (!_.isNull(indexOf) && indexOf >= 0) {
          arr.splice(indexOf, 1);
        }
      } else {
        arr = arr.filter((item) => item.field != 'rebate');
        arr.push({
          field: 'rebate',
          errorType: 'required',
          message: REBATE_PROGRAM_REQUIRED,
        });
      }
    }

    const unique = [...new Set(arr)];

    dispatch(dispatchErrorMessageData(unique));
  };

  const onFilterChangedGrid = useCallback((e) => {
    setTotalResultCount(e.api.getDisplayedRowCount());
    if (
      e.api.getFilterModel() &&
      Object.keys(e.api.getFilterModel()).length > 0
    ) {
      setIsFilter(true);
    } else {
      setIsFilter(false);
    }
  }, []);

  //  change plan type function
  const handlePlanType = (data) => {
    dispatch(
      setSelectedRebateProgram({
        plan: data,
        rebateProgram: '-1',
      })
    );
  };
  return (
    <div
      className='tBillPanel custom-check tabs-container'
      data-testid='check-by-invoice-component'
    >
      <div>
        <Spinner load={loading} />
        {!fullScreenView && (
          <CustomSeparator
            parent1='Tasks'
            parent2='View Check by Associated Invoices'
          />
        )}
        {getErrorMsg?.length > 0 ? (
          <DisplayErrorMessages
            errorMessages={
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            }
          />
        ) : null}
        <div>
          <div className='no-margin'>
            {!fullScreenView && !fullScreenViewForChecks && (
              <div className='row mb-2'>
                <div className='col-12 col-md-5 frr-checkInvoiceRadio frr-two-col-radio'>
                  <RadioGroupComponent
                    data-testid='filter-plan-by-radio-btn'
                    id='filter-plan-by-radio-btn-action'
                    labelName={radioGroupLabelName}
                    required={false}
                    optionList={radioList || []}
                    defaultValue={planType}
                    filterAction={(e) => {
                      handlePlanType(e);
                    }}
                    className='log-batch-filter-radio frr-checkInvoiceRadio'
                  />
                </div>
                <div className='col-12 col-md-7 frr-checkInvoiceRebate'>
                  <div className='mt-2'>
                    <fieldset className='custom-fieldset'>
                      <legend aria-hidden='true' className='d-none' />
                      <div className='form-wrapper my-2'>
                        <div className='mui-custom-form with-select '>
                          <TextField
                            data-testid='rebate_program-cbi'
                            id='rebate_program'
                            label={rebateProgramLabelName}
                            fullWidth
                            className={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'rebate'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            select
                            required
                            placeholder=''
                            inputProps={{ maxLength: 11, id: 'rebate_program' }}
                            error={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'rebate' ? l.message : null
                                  )
                                : null
                            }
                            helperText={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'rebate' ? l.message : null
                                  )
                                : null
                            }
                            onBlur={(e) =>
                              onBlurFunction('rebate', e.target.value)
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={rebateProgram}
                            onChange={(e) => {
                              dispatch(
                                setSelectedRebateProgram({
                                  plan: planType,
                                  rebateProgram: e.target.value,
                                })
                              );
                            }}
                          >
                            <MenuItem
                              key=''
                              value='-1'
                              className='frr-dropdown-blank-item'
                            />
                            {rebateProgramList?.length > 0
                              ? rebateProgramList.map((item, key) => {
                                  return (
                                    <MenuItem key={key} value={item.id}>
                                      {item.name}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                        <div className='mui-custom-form input-md frr-check-invoice-quater'>
                          <TextField
                            data-testid='check_quarter_cbi'
                            id='check_by_invoice_quater'
                            required
                            className={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field == 'quarter'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            label={quarterLabelName}
                            fullWidth
                            placeholder=''
                            inputProps={{ maxLength: 6 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={quarterValue}
                            onChange={quarterChangeHandler}
                            onBlur={() =>
                              onBlurFunction('quarter', quarterValue)
                            }
                            error={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field == 'quarter' ? l.message : null
                                  )
                                : null
                            }
                            helperText={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field == 'quarter' ? l.message : null
                                  )
                                : null
                            }
                          />
                        </div>
                        <div className='mui-custom-form input-md pt-3 frr-checkinvoice-search'>
                          <Button
                            className='btn btn-success btn-search'
                            data-testid='check_search_cbi'
                            disabled={searchDisable || false}
                            onClick={() => {
                              onSearch(false);
                            }}
                          >
                            <SVGComponent iconName='Icon-search' />
                            {'  '}
                            Search
                          </Button>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            )}
            {!fullScreenViewForChecks && mfgDetailslist && (
              <div className='row'>
                <div className='col-sm-12'>
                  <TableGridWithFeatures
                    data-testid='manufacturer-cbi-table'
                    rowSelection='single'
                    rowMultiSelectWithClick={false}
                    fullScreenView={fullScreenView}
                    handleFullScreenViewClick={handleFullScreenView}
                    gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
                    rowData={mfgDetailslist}
                    columnDefs={TableHeaderForManufacturer}
                    exportFile
                    animateRows
                    sideBar={false}
                    gridCall={onGridReady}
                    onFilterChanged={onFilterChangedGrid}
                    fileName='Check_Associated_Invoices-Manufacturer'
                    singleClickEdit
                    navigateToNextCell={navigateToNextCell}
                    //tabToNextCell={tabToNextCell}
                    enterMovesDown
                    suppressCellFocus
                    onCellFocused={onCellFocused}
                    onSelect={(e, reduxState) => {
                      onRowSelect(e.data, '', reduxState);
                    }}
                    reduxState={{ ...selectedData, quarterValue }}
                  />
                </div>
              </div>
            )}
            {!fullScreenView && (
              <div className='row'>
                <div className='col-sm-12 frr-log_chk'>
                  {getErrorMsg?.length > 0 ? (
                    <DisplayErrorMessages
                      errorMessages={
                        getErrorMsg?.length > 0
                          ? _.filter(
                              getErrorMsg,
                              (l) => l.field == 'checkGrid' && l.message
                            ).map((val) => val.message)
                          : []
                      }
                    />
                  ) : null}

                  <TableGridWithFeatures
                    data-testid='checks-cbi-table'
                    rowSelection='single'
                    hideColumnsInPdf={hideColumns}
                    rowMultiSelectWithClick={false}
                    fullScreenView={fullScreenViewForChecks}
                    handleFullScreenViewClick={handleFullScreenViewForChecks}
                    gridHeight={
                      fullScreenView ? '70vh' : viewPortHeight_350_cbi
                    }
                    columnDefs={colHeadCheck}
                    rowData={getCheckList}
                    exportFile
                    animateRows
                    frameworkComponents={frameworkComponents}
                    fileName='Chks_By_Associated_Invoices'
                    // gridCall={onGridReady}
                    onFilterChanged={onFilterChangedGrid}
                    navigateToNextCell={navigateToNextCell}
                    //tabToNextCell={tabToNextCell}
                    isScrollOn
                    enterMovesDown
                    suppressCellFocus
                    onCellFocused={onCellFocused}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChecksByInvoice;
